import type * as LeasedTag from "../../lib/models/leased-tag.server.ts"

import type { GroupedByProduct } from "../../lib/models/leased-tag.server.ts"

import * as UI from "@iyk/ui"
import * as React from "react"

import { Await } from "@remix-run/react"
import { useIykUser } from "../../lib/hooks/use-iyk-user.ts"

export function AsyncUserOwnedItemIndicator({
  itemId,
  currentUserOwnedItemsPromise,
}: {
  itemId: string
  currentUserOwnedItemsPromise: ReturnType<typeof LeasedTag.getFromUserGroupedByProduct>
}) {
  return (
    <React.Suspense fallback={null}>
      <Await resolve={currentUserOwnedItemsPromise}>
        {(currentUserItems) => (
          <UserOwnedItemIndicator itemId={itemId} currentUserItems={currentUserItems} />
        )}
      </Await>
    </React.Suspense>
  )
}

export function UserOwnedItemIndicator({
  itemId,
  currentUserItems,
}: {
  itemId: string
  currentUserItems: GroupedByProduct | null
}) {
  const { iykUser } = useIykUser()

  const isCurrentUserOwned = Boolean(currentUserItems?.[itemId])
  if (!isCurrentUserOwned) return null
  return (
    <div className="flex items-center gap-1.5">
      <UI.Avatar src={iykUser?.avatarUrl ?? undefined} className="size-4" />
      <span className="text-xs">You own this</span>
    </div>
  )
}
